import { CustomNode } from '../../../types';
import { callWebhookIcon } from '../../../icons';

const DEFAULT_ICON = callWebhookIcon;

export const callWebhookConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
